import React from 'react'

/* Explicit hex: CSS variables in SVG fill/stroke are unreliable across browsers. Theme pink #f7426f = --clr-theme-1 */

const P = '#f7426f'
const MUTED = '#5c6368'
const LIGHT = '#e8e8e8'
const P_SOFT = 'rgba(247, 66, 111, 0.12)'

const wrap = (children: React.ReactNode, label: string) => (
  <div className="sign__wizard-ill" role="img" aria-label={label}>
    {children}
  </div>
)

export function IconEventName() {
  return wrap(
    <svg
      className="sign__wizard-svg sign__wizard-svg--float"
      viewBox="0 0 120 120"
      width={120}
      height={120}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="20"
        y="24"
        width="80"
        height="72"
        rx="12"
        fill={P_SOFT}
        stroke={P}
        strokeWidth="2.5"
      />
      <rect
        x="32"
        y="40"
        width="44"
        height="6"
        rx="3"
        fill={MUTED}
        className="sign__wizard-illShimmer"
      />
      <rect
        x="32"
        y="54"
        width="28"
        height="4"
        rx="2"
        fill={MUTED}
        opacity="0.55"
      />
      <circle className="sign__wizard-illPing" cx="92" cy="36" r="6" fill={P} />
    </svg>,
    'Event',
  )
}

export function IconEventUrl() {
  return wrap(
    <svg
      className="sign__wizard-svg sign__wizard-svg--sway"
      viewBox="0 0 120 120"
      width={120}
      height={120}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44 64c0-12 10-22 22-22h6"
        fill="none"
        stroke={P}
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M76 64c0 12-10 22-22 22h-6"
        fill="none"
        stroke={MUTED}
        strokeWidth="3.5"
        strokeLinecap="round"
        opacity="0.7"
      />
      <rect
        x="30"
        y="78"
        width="60"
        height="14"
        rx="4"
        fill={LIGHT}
        stroke={MUTED}
        strokeWidth="1"
      />
      <rect
        x="38"
        y="84"
        width="36"
        height="4"
        rx="2"
        fill={MUTED}
        opacity="0.4"
      />
    </svg>,
    'URL',
  )
}

export function IconLocale() {
  return wrap(
    <svg
      className="sign__wizard-svg sign__wizard-svg--rotate"
      viewBox="0 0 120 120"
      width={120}
      height={120}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="60"
        cy="60"
        r="32"
        fill="none"
        stroke={P}
        strokeWidth="2.5"
        opacity="0.45"
      />
      <ellipse
        cx="60"
        cy="60"
        rx="32"
        ry="14"
        fill="none"
        stroke={P}
        strokeWidth="2.2"
        opacity="0.95"
      />
      <path
        d="M28 60h64M60 28c8 10 8 24 0 64"
        fill="none"
        stroke={MUTED}
        strokeWidth="2"
        opacity="0.65"
      />
    </svg>,
    'Language',
  )
}

export function IconReady() {
  return wrap(
    <svg
      className="sign__wizard-svg"
      viewBox="0 0 120 120"
      width={120}
      height={120}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="sign__wizard-readyRing"
        cx="60"
        cy="60"
        r="38"
        fill="none"
        stroke={P}
        strokeWidth="2.5"
        strokeDasharray="4 6"
        opacity="0.6"
      />
      <path
        d="M46 60l8 8 20-20"
        fill="none"
        stroke={P}
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="sign__wizard-readyPath"
      />
    </svg>,
    'Ready',
  )
}
